import { render, staticRenderFns } from "./TraxSettingBackgroundCrudTable.vue?vue&type=template&id=0f60248c"
import script from "./TraxSettingBackgroundCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxSettingBackgroundCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports